import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AdditionalWorkflowLaunchWrapper from './AdditionalWorkflowLaunchWrapper';
import AdditionalWorkflowKeyDatesPage from './AdditionalWorkflowKeyDatesPage';
import AdditionalWorkflowAllTasksPage from './AdditionalWorkflowAllTasksPage';
import AdditionalWorkflowPartiesPage from './AdditionalWorkflowPartiesPage';
import AdditionalWorkflowConflictsPage from './AdditionalWorkflowConflictsPage';
import ArchivedProjectChecker from '../ArchivedProjectChecker';

export default function AdditionalWorkflowRouter() {
  return (
    <AdditionalWorkflowLaunchWrapper>
      <Routes>
        <Route
          path="conflicts"
          element={(
            <ArchivedProjectChecker>
              <AdditionalWorkflowConflictsPage />
            </ArchivedProjectChecker>
          )}
        />
        <Route
          path="keydates"
          element={(
            <ArchivedProjectChecker>
              <AdditionalWorkflowKeyDatesPage />
            </ArchivedProjectChecker>
          )}
        />
        <Route
          path="alltasks"
          element={(
            <ArchivedProjectChecker>
              <AdditionalWorkflowAllTasksPage />
            </ArchivedProjectChecker>
          )}
        />
        <Route
          path="parties"
          element={(
            <ArchivedProjectChecker>
              <AdditionalWorkflowPartiesPage />
            </ArchivedProjectChecker>
          )}
        />
      </Routes>
    </AdditionalWorkflowLaunchWrapper>
  );
}
